import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(public)/[locale]/error.tsx");
